import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";
import { sanitizeParameter, sanitizeNumericParameter, setPortalActiveMenu } from "libraries/common_functions";

import React from "react";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const UTILITIES_ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/portal_utilities';
const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/get_campaigns';

class PortalTrackUrl extends React.Component {
    constructor(){
        super();
        this.state = {
            isloggedin: false,
            alertColor: '',
            campaign: '',
            utm_source: '',
            page_no: 1,
            query: '',
            rstatus: '',
            rmessage: '',
            rdata: []
        }

        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
        });
    }

    async getTrackingData(){
        const location = window.location;
        const queryParams = new URLSearchParams(location.search);

        var page_no = sanitizeNumericParameter(queryParams.get('page_no'));
        var campaign = sanitizeParameter(queryParams.get('campaign'));
        var utm_source = sanitizeParameter(queryParams.get('utm_source'));

        this.setState({campaign: campaign});
        this.setState({utm_source: utm_source});

        var data = {campaign: campaign, utm_source: utm_source, page_no: page_no};

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            rdata: rdata,
            page_no: page_no,
            query: location.search
        });

        if (rstatus === true){ 
            this.setState({alertColor: 'green'}); 
        } 
        else if (rstatus === false) { 
            this.setState({alertColor: 'red'}); 
        }
    }

    async getCampaigns(){
        var data = {action:  'get_utm_sources'};

         // eslint-disable-next-line
        const {rstatus, rmessage, rdata } = await callAPI(UTILITIES_ENDPOINT, data);
        if (rstatus === true){ 
            var campaignSelect = document.getElementsByName('utm_source')[0];
            if (rdata.utm_sources.length > 0){ 
				for (var i=0; i<rdata.utm_sources.length; i++){
					campaignSelect.options.add(new Option(rdata.utm_sources[i].utm_source, rdata.utm_sources[i].utm_source));
                    campaignSelect.options[i+1].selected = rdata.utm_sources[i].utm_source === this.state.utm_source;
				}
            }
        } 
    }

    componentDidMount(){
        setPortalActiveMenu('short_url');

        this.getTrackingData();
        this.getCampaigns();
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />
                        
                    <div className="content">
                            
                        <PortalTopMenu page_name="Track URL" />

                        <div className="intro-y flex items-center mt-8">
                            <h2 className="text-lg font-medium mr-auto">
                                Track URL
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">
                                    <div className="p-5" id="horizontal-form">
                                        <form className="preview" method="get">
                                            <div className="flex flex-col sm:flex-row items-center mt-3">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Campaign Name</label>
                                                    <input type="text" name="campaign" defaultValue={this.state.campaign} className="input w-full border mt-2 flex-1" placeholder="Enter campaign name" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">UTM Source</label>
                                                    <select name="utm_source" className="input w-full border mt-2 flex-1" defaultValue="" >
                                                        <option value="">Select a campaign</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center mt-5">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <button type="submit" className="button bg-theme-3 text-white w-1/4">Search</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">

                                    { this.state.rstatus === true ?

                                        this.state.rdata.campaigns_data.length > 0 ?

                                            <>
                                                <div className="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200">
                                                    <h2 className="font-medium text-base mr-auto">
                                                        Campaigns Data
                                                    </h2>
                                                </div>
                                                <div className="p-5" id="basic-table">
                                                    <div className="preview">
                                                        <div className="overflow-x-auto">
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">#</th>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">Campaign Name</th>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">Destination URL</th>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">Shortened URL</th>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">UTM Source</th>
                                                                        <th className="border-b-2 dark:border-dark-5 whitespace-no-wrap">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                {this.state.rdata.campaigns_data.map(function(campaign, i){
                                                                        return (
                                                                            <tr key={`key_${i+1}`}>
                                                                                <td className="border-b dark:border-dark-5">{i+1}</td>
                                                                                <td className="border-b dark:border-dark-5">{campaign.campaign_name}</td>
                                                                                <td className="border-b dark:border-dark-5" style={{color: 'blue'}}>{campaign.destination_url}</td>
                                                                                <td className="border-b dark:border-dark-5" style={{color: 'blue'}}>{campaign.shortened_url}</td>
                                                                                <td className="border-b dark:border-dark-5">{campaign.utm_source.toUpperCase()}</td>
                                                                                <td className="border-b dark:border-dark-5" style={{color: 'green'}}>{campaign.tracking_enabled ? <a href={`/portal/url/details/?id=${campaign.campaign_id}`}>Track</a> : '--' }</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-6" style={{padding: "10px", float: "right"}}>
                                                    <ul className="pagination">
                                                        <li className="items-center">
                                                            <a className="pagination__link" href={this.state.page_no > 1 ? `/portal/url/track?${this.state.query}&page_no=${this.state.page_no-1}` : "#/"}> <i className="w-4 h-4" data-feather="chevron-left"></i> </a>
                                                        </li>
                                                        <li className="items-center"> 
                                                            <a className="pagination__link" href="#/"><span className="w-4 h-4" style={{position: "relative", right: "-3px", top: "-2px"}}>{this.state.page_no}</span></a> 
                                                        </li>
                                                        <li className="items-center">
                                                            <a className="pagination__link" href={this.state.page_no < this.state.rdata.total_pages ? `/portal/url/track?${this.state.query}&page_no=${this.state.page_no+1}` : "#/"}> <i className="w-4 h-4" data-feather="chevron-right"></i> </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </>
                                    

                                        :

                                        <p style={{ color: "red", padding: "10px"}}>
                                            There is no data to show!
                                        </p>

                                    :

                                        <p style={{ color: this.state.alertColor, padding: "10px"}}>
                                            {this.state.rmessage}
                                        </p>

                                    }

                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalTrackUrl;
